<template>
<div class="HeroList">
    <Appbar :title="heroListTitle">
    <!-- <span text slot="left"></span> -->
    </Appbar>

    <template>
    <v-simple-table>
        <template v-slot:default>
        <thead>
            <tr>
                <th>用户名</th>
                <th>{{ app_my_config.winPrize.name }}{{app_my_config.amount.name}}</th>
                <th>项目</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item,i) in heroList" :key="i">
                <td class="name d-flex align-center">
                    <img v-if="i<3" class="cup mx-1" :src="require('../../static/pages/home/cup'+i+'.png')" alt="">
                    <div v-else class="icon mx-2">{{i+1}}</div>
                    {{ item.memberAccount.slice(0,3) }}*****
                </td>
                
                <td class="tip-color">
                    <template v-if="heroListShowMode === 'money'">
                    {{ rtext1.split(',').length > 1 ? rtext1.split(',')[$tools.random(0, rtext1.split(',').length - 1)] : `${rtext1}` }}{{ item.amount }}{{app_my_config.amountUnit.name}}
                    </template>
                    <template v-if="heroListShowMode === 'number'">
                    {{ rtext1.split(',').length > 1 ? rtext1.split(',')[$tools.random(0, rtext1.split(',').length - 1)] : `${rtext1}` }}{{ Math.floor(item.amount).toString().slice(0, heroListNumberLength) }}次
                    </template>
                    <template v-if="heroListShowMode === 'text'">
                    <template v-if="isHeroListCustom">
                        {{ rtext1.split(',').length > 1 ? rtext1.split(',')[$tools.random(0, rtext1.split(',').length - 1)] : `${rtext1}` }}<template v-if="heroListTextModeReward.length > 0">{{ heroListTextModeReward[$tools.random(0, heroListTextModeReward.length - 1)].name }}</template>
                    </template>
                    <template v-else>
                        {{ rtext1.split(',').length > 1 ? rtext1.split(',')[$tools.random(0, rtext1.split(',').length - 1)] : `${rtext1}` }}<template v-if="heroListTextModeReward.length > 0">{{ index &lt; heroListTextModeReward.length ? heroListTextModeReward[index].name : heroListTextModeReward[(index % heroListTextModeReward.length)].name }}</template>
                    </template>
                    </template>
                </td>

                <td v-if="heroListTips">
                    <template v-if="typeof(heroListTips) == 'string'">
                    {{ heroListTips }}
                    </template>
                    <template v-if="typeof(heroListTips) == 'object'">
                    {{ heroListTips[$tools.random(0, heroListTips.length - 1)].name }}
                    </template>
                </td>
                <td v-else>
                    {{ item.rewardName }}
                </td>
            </tr>
        </tbody>
        </template>
    </v-simple-table>
    </template>

</div>
</template>

<script>
import appConfig from "@c/mixins/appConfig.mixins";
import Appbar from "@c/layout/Appbar";
import {
  ApigetAdminlooprewardList,
  } from "@/api/service.js"
export default {
    mixins: [appConfig],
    components: {
        Appbar,
    },
    data(){
        return{
            heroList:[]
        }
    },
    computed: {
        isSex() {
            return this._config.app_config.configValue.template&&this._config.app_config.configValue.template.isSex ? this._config.app_config.configValue.template.isSex : false
        },
        rtext1() {
            return this.app_my_config.herolistRtext1.name
        },
        // 英雄榜显示为次数（xxx次）还是金额 （xxx 元），默认显示金额(money),次数配置参数为（number）
        heroListShowMode() {
            let defaultMode = 'money'
            if(this._config.app_config.configValue.template&&this._config.app_config.configValue.template.heroListShowMode) {
                return this._config.app_config.configValue.template.heroListShowMode
            } else {
                return defaultMode
            }
        },
        heroListNumberLength() {
            let defaultLength = 3
            if(this._config.app_config.configValue.template&&this._config.app_config.configValue.template.heroListNumberLength) {
                return this._config.app_config.configValue.template.heroListNumberLength
            } else {
                return defaultLength
            }
        },
        heroListTitle() {
            if(this.isSex) {
                let defaultTitle = '约炮英雄榜'
                if(this._config.app_config.configValue.template&&this._config.app_config.configValue.template.heroListTitle) {
                return this._config.app_config.configValue.template.heroListTitle
                } else {
                return defaultTitle
                }
            } else {
                let defaultTitle = '最新英雄榜'
                if(this._config.app_config.configValue.template&&this._config.app_config.configValue.template.heroListTitle) {
                return this._config.app_config.configValue.template.heroListTitle
                } else {
                return defaultTitle
                }
            }
        },
        heroListTips() {
            if(this.isSex) {
                let defaultTips = '约炮成功'
                if(this._config.app_config.configValue.template&&this._config.app_config.configValue.template.heroListTips) {
                return this._config.app_config.configValue.template.heroListTips
                } else {
                return defaultTips
                }
            } else {
                let defaultTips = null
                if(this._config.app_config.configValue.template&&this._config.app_config.configValue.template.heroListTips) {
                return this._config.app_config.configValue.template.heroListTips
                } else {
                return defaultTips
                }
            }
        },
        heroListTextModeReward() {
            return this._config.app_config.configValue.template.heroListTextModeReward ? this._config.app_config.configValue.template.heroListTextModeReward : []
        },
        // 盈利金额数据是否打乱,true随机，false按顺序
        isHeroListCustom() {
            return this._config.app_config.configValue.template&&this._config.app_config.configValue.template.isHeroListCustom ? this._config.app_config.configValue.template.isHeroListCustom : false
        }
    },
    methods:{
        getHroList() {
            if(this.isHeroListCustom) {
                ApigetAdminlooprewardList({limit:999,page:1}).then((res) => {
                if (res.code == "12200") {
                    this.heroList.push(...res.data.list);
                    this.heroList = this.$tools.randomArray(this.heroList)
                }
                });
            } else {
                ApigetAdminlooprewardList().then((res) => {
                if (res.code == "12200") {
                    this.heroList.push(...res.data.list);
                }
                });
            }
        },
    },
    created(){
        this.getHroList()
    }
}
</script>

<style lang="scss" scoped>
.HeroList{
    height: 100%;
    overflow: auto;
    font-size: 14px;
    .v-data-table th{
        font-size: 14px;
        text-align: center;
        background-color:#eee;
        // color: inherit !important;
    }
    .v-data-table td{
        font-size: 14px;
        padding: 0;
    }
    .icon {
         width: 22px;
         height: 22px;
         background:url('../../static/pages/home/cup3.png') no-repeat center center;
         background-size: 100% 100%;
        color: #fff;
        text-align: center;

    }
    .cup{
        width: 28px;
    }
}
</style>